import axios, { isAxiosError } from 'axios'

import Config from '@/config/config'
import { logger, LOGGER_LEVEL } from '@/network/common/logger'

import { getCookie, getUserIdFromAuthToken } from '../providers/authentication/authentication.helpers'

import { makeId } from './id'
import { refreshAuthToken } from './refresh-auth-token'

import type { AxiosRequestConfig, AxiosResponse } from 'axios'

interface InternalRequest extends AxiosRequestConfig {
  dispatch?(any: any): void
}

const internalRequest = async ({
  dispatch = () => {},
  url,
  ...props
}: InternalRequest): Promise<AxiosResponse<any>> => {
  const userId = getUserIdFromAuthToken()

  if (props.headers && props.headers.authorization) {
    const authorizationFromCookieAndNotRedux = getCookie('token')
    props.headers.authorization = authorizationFromCookieAndNotRedux
  }

  const refreshToken = getCookie('refreshToken')
  const tokenExpiresAt = getCookie('tokenExpiresAt')

  const canRefreshAuthToken = refreshToken && tokenExpiresAt && userId

  const refreshAuthTokenResponse = canRefreshAuthToken
    ? await refreshAuthToken({
        userId,
        refreshToken: refreshToken,
        tokenExpiresAt: new Date(tokenExpiresAt),
      })
    : undefined

  if (refreshAuthTokenResponse?.token) {
    dispatch({ type: 'authentication/refreshAuthToken', payload: refreshAuthTokenResponse })
    if (props.headers && props.headers.authorization) {
      props.headers.authorization = refreshAuthTokenResponse.token
    }
  }

  const uuid = makeId(9)
  const separator = url?.toString().includes('?') ? '&' : '?'
  try {
    const result = await axios({
      validateStatus: (status) => status >= 200 && status < 300,
      url: `${Config.SERVER_URL}${url}${separator}uuid=${uuid}`,
      ...props,
    })

    return result
  } catch (error: Error | unknown) {
    logger({
      level: LOGGER_LEVEL.ERROR,
      message: 'Axios error',
      meta: {
        // @ts-expect-error message is not in type unknown
        error: error?.message,
        url,
        uuid,
      },
    })
    if (isAxiosError(error)) {
      const { response } = error

      if (response?.status === 401) dispatch({ type: 'authentication/logout' })
    }

    throw error
  }
}

export { internalRequest }
